import React from 'react';
import PropTypes from 'prop-types';
import {
  CardCvcElement,
  CardExpiryElement,
  CardNumberElement,
} from '@stripe/react-stripe-js';
// doing this style of import to cut down on size (30kb)
import _cloneDeep from 'lodash/cloneDeep';

import ZeroPaymentBox from './ZeroPaymentBox';

const baseElementOptions = {
  style: {
    base: {
      color: '#424770',
      fontFamily: '"Satoshi", Helvetica, Arial, sans-serif',
      lineHeight: '1.5rem',
      '::placeholder': {
        color: '#aab7c4',
      },
    },
    invalid: {
      color: '#9e2146',
    },
  },
};

const cardNumberOptions = _cloneDeep(baseElementOptions);
cardNumberOptions.showIcon = true;

const PaymentInfo = ({
  paymentInfoSectionHeader = null,
  validateCardNumber,
  validateCardExpiry,
  validateCardCVC,
  cardFields,
  amountOwed,
}) => {
  const displyZeroPaymentBox = () => {
    return (
      <ZeroPaymentBox copy="No payment information required" />
    );
  };

  // Displays the payment info
  const displayPaymentInfo = () => {
    const { cardNumber, cardExpiry, cardCVC } = cardFields;
    return (
      <form>
        <div className="explanation-text">
          Unable to pay with credit card? Request a purchase order
          {' '}
          <a href={window.divewire.faqUrl} target="_blank" rel="noreferrer">here</a>.
        </div>
        <div>
          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
          <label>
            <div className="payment-info-label">Card number:</div>
            <span className="form__required-tag">*</span>
            <div className={!cardNumber.valid ? 'stripe-element-input form-error__highlight' : 'stripe-element-input'}>
              <CardNumberElement
                options={cardNumberOptions}
                onChange={validateCardNumber}
              />
            </div>
            {!cardNumber.valid && cardNumber.error && <p className="form-error__message">{cardNumber.error}</p>}
          </label>
        </div>
        <div className="expiry-cvc-container">
          <div className="expiry-cvc-container__expiration_date">
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <label>
              <div className="payment-info-label">Expiration date:</div>
              <span className="form__required-tag">*</span>
              <div className={!cardExpiry.valid ? 'stripe-element-input form-error__highlight' : 'stripe-element-input'}>
                <CardExpiryElement
                  options={baseElementOptions}
                  onChange={validateCardExpiry}
                />
              </div>
              {!cardExpiry.valid && cardExpiry.error && <p className="form-error__message">{cardExpiry.error}</p>}
            </label>
          </div>
          <div className="expiry-cvc-container__cvc">
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <label>
              <div className="payment-info-label">CVC:</div>
              <span className="form__required-tag">*</span>
              <div className={!cardCVC.valid ? 'stripe-element-input form-error__highlight' : 'stripe-element-input'}>
                <CardCvcElement
                  options={baseElementOptions}
                  onChange={validateCardCVC}
                />
              </div>
              {!cardCVC.valid && cardCVC.error && <p className="form-error__message">{cardCVC.error}</p>}
            </label>
          </div>
        </div>
      </form>
    );
  };

  return (
    <div className="payment-info-wrapper">
      {paymentInfoSectionHeader && <h2 className="payment-info-wrapper__header__text heading-01">{paymentInfoSectionHeader}</h2>}
      {/* When the amount owed is greater than zero we want to require the credit card payment
      info, but when the amount owed is zero we want to display the 'no payment required'
      banner. */}
      {amountOwed > 0
        ? displayPaymentInfo()
        : displyZeroPaymentBox()}
    </div>
  );
};

PaymentInfo.propTypes = {
  paymentInfoSectionHeader: PropTypes.string,
  validateCardNumber: PropTypes.func.isRequired,
  validateCardExpiry: PropTypes.func.isRequired,
  validateCardCVC: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  cardFields: PropTypes.object.isRequired,
  amountOwed: PropTypes.number.isRequired,
};

export default PaymentInfo;
